import { render, staticRenderFns } from "./RecentInProgressCard.vue?vue&type=template&id=262fb574&"
import script from "./RecentInProgressCard.vue?vue&type=script&lang=js&"
export * from "./RecentInProgressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262fb574')) {
      api.createRecord('262fb574', component.options)
    } else {
      api.reload('262fb574', component.options)
    }
    module.hot.accept("./RecentInProgressCard.vue?vue&type=template&id=262fb574&", function () {
      api.rerender('262fb574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/RecentInProgressCard.vue"
export default component.exports